/**
 * The /compare hub: the page every `/compare/<slug>` article's breadcrumb and
 * category chip point back to. The articles themselves are company-blog posts
 * published on goodsender.com (#1485); this copy frames the list of them.
 */
export const COMPARE_PAGE = {
  eyebrow: "Comparisons",
  title: "GoodSender compared",
  lede: "How GoodSender stacks up against the blog and newsletter platforms writers weigh it against: what each does well, what it costs, and when to pick which.",
  empty: "Comparisons are on their way. Check back soon.",
  readLabel: "Read the comparison",
} as const;
